










import Vue from 'vue';

export default Vue.extend({
    name: 'Icon',
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        /** Whether the icon is a simple text-icon, rather than one defined through icomoon */
        isTextIcon: {
            type: Boolean,
            default: false,
        },
    },
});
